import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { updateProduct } from "../api/PupilApi";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from './Navbar';
import Footer from './Footer';
import { categoriesList } from "../constant/Constant";


const EditProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentDate = new Date();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
  const year = currentDate.getFullYear();
  const { product } = location.state || {};
  //alert("product" + JSON.stringify(product));
  const initialData = {
    category: product.category || "",
    subcategory: product.subcategory || "",
    size: product.size || "",
    productName: product.productName || "",
    dealerPrice: product.dealerPrice || "",
    quantity: product.quantity || "",
    productDescription: product.productDescription || "",
    sellingPrice: product.sellingPrice || "",
    email: `orgData${month}${year}@yaazhtech.com`,
    stockType: product.stockType || "",
    designName: product.designName || "",
    onboardDate: product.onboardDate || "",
    _id: product._id || "",
  };

  const [formData, setFormData] = useState(initialData);
  const [error, setError] = useState("");


const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prevData) => {
    let updatedData = { ...prevData, [name]: value };

    if (name === "category") {
      updatedData.subcategory = "";
      updatedData.productName = "";
    }

    if (name === "subcategory") {
      updatedData.productName = "";
    }

    if (name === "productName" && value) {
      const selectedProduct = categoriesList[updatedData.category]?.[updatedData.subcategory]?.find(
        (product) => {
          if (typeof product === "string") {
            return product === value;
          } else {
            return Object.keys(product)[0] === value;
          }
        }
      );

      if (selectedProduct) {
        const productDetails = typeof selectedProduct === "string" ? {} : selectedProduct[value];
        updatedData = {
          ...updatedData,
          productDescription: productDetails.productDescription || "",
          stockType: productDetails.stockType || "",
          dealerPrice: productDetails.dealerPrice || "",
          sellingPrice: productDetails.sellingPrice || "",
          designName: productDetails.designName || "",
        };
      }
    }

    return updatedData;
  });
};
  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    const jsonData = { ...formData };

    updateProduct(jsonData)
      .then((res) => {
        toast.success(res.data.message);
      })
      .catch((error) => {
        toast.error(error.message || "Something went wrong. Please try again!");
      });
  };

  const handleClear = () => {
    setFormData(initialData);
  };

  return (
    <>
      <Navbar />
      <div className="flex items-center justify-center min-h-screen bg-green-200 p-6 font-serif">
        <form onSubmit={handleSubmit} className="w-full max-w-5xl bg-white p-8 rounded-lg shadow-lg font-sans">
          <h1 className="text-3xl font-bold text-center text-orange-800 mb-6">Add New Product</h1>

          {error && <div className="text-red-600 text-sm text-center bg-red-100 p-2 rounded-md">{error}</div>}

          {/* Form Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-blue-200 p-6 rounded-lg shadow-md">
            {/* Category Selection */}
            <div className="flex flex-col">
              <label htmlFor="category" className="text-lg font-medium text-gray-700">Category</label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
                className="mt-1 p-3 border rounded-md shadow-sm text-gray-800 text-lg"
              >
                <option value="" disabled>Select a category</option>
                {Object.keys(categoriesList).map((cat) => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
              </select>
            </div>

            {/* Subcategory Selection */}
            {formData.category && (
              <div className="flex flex-col">
                <label htmlFor="subcategory" className="text-lg font-medium text-gray-700">Subcategory</label>
                <select
                  id="subcategory"
                  name="subcategory"
                  value={formData.subcategory}
                  onChange={handleChange}
                  className="mt-1 p-3 border rounded-md shadow-sm text-gray-800 text-lg"
                >
                  <option value="" disabled>Select a subcategory</option>
                  {Object.keys(categoriesList[formData.category] || {}).map((sub) => (
                    <option key={sub} value={sub}>{sub}</option>
                  ))}
                </select>
              </div>
            )}
            <>
{
  formData.subcategory && (
    <div className="flex flex-col">
      <label htmlFor="productName" className="text-lg font-medium text-gray-700">
        Product Name
      </label>
      <select
        id="productName"
        name="productName"
        value={formData.productName}
        onChange={handleChange}
        className="mt-1 p-3 border rounded-md shadow-sm text-gray-800 text-lg"
      >
        <option value="" disabled>
          Select a product name
        </option>
        {categoriesList[formData.category]?.[formData.subcategory]?.map((product) => {
          // Handle both objects and strings
          if (typeof product === "string") {
            return (
              <option key={product} value={product}>
                {product}
              </option>
            );
          } else {
            // If it's an object, extract the key (product name)
            const productName = Object.keys(product)[0];
            return (
              <option key={productName} value={productName}>
                {productName}
              </option>
            );
          }
        })}
      </select>
    </div>
  )
}
</>
            {/* Other Input Fields */}
            {["dealerPrice", "size", "productDescription", "quantity", "stockType", "onboardDate", "designName", "sellingPrice"].map((field) => (
  <div key={field} className="flex flex-col">
    <label htmlFor={field} className="text-lg font-medium text-gray-700 capitalize">
      {field.replace(/([A-Z])/g, " $1")}
    </label>

    {field === "stockType" ? (
      // Dropdown for stockType
      <select
        id={field}
        name={field}
        value={formData[field]}
        onChange={handleChange}
        className="mt-1 p-3 border rounded-md shadow-sm text-gray-800 text-lg"
      >
        <option value="" disabled>Select Stock Type</option>
        <option value="Available">Available</option>
        <option value="Out of Stock">Out of Stock</option>
        <option value="Pre-Order">Pre-Order</option>
        <option value="In Stock">In Stock</option>
      </select>
    ) : (
      // Input for all other fields
      <input
        type={field === "onboardDate" ? "date" : "text"}
        id={field}
        name={field}
        value={formData[field]}
        onChange={handleChange}
        className="mt-1 p-3 border rounded-md shadow-sm text-gray-800 text-lg"
        placeholder={`Enter ${field.replace(/([A-Z])/g, " $1")}`}
      />
    )}
  </div>
))}

          </div>

          {/* Buttons */}
          <div className="flex justify-between mt-6">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="bg-gray-500 text-white px-6 py-3 rounded-md hover:bg-gray-600 text-lg font-bold"
            >
              Back
            </button>

            <button
              type="button"
              onClick={handleClear}
              className="bg-red-500 text-white px-6 py-3 rounded-md hover:bg-red-600 text-lg font-bold"
            >
              Clear
            </button>

            <button type="submit" className="bg-indigo-600 text-white px-8 py-3 rounded-md hover:bg-indigo-700 text-lg font-bold">
              Update Product
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default EditProduct;
